import { cloneDeep } from 'lodash';
import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import ColumnsBlockView from '@eeacms/volto-columns-block/ColumnsBlock/ColumnsBlockView';
import ButtonView from '../src/components/Blocks/Button/View';
import { buttonSchemaEnhancer } from '../src/components/Blocks/Button/button_schema_enhancer';
import { buttonStyleSchemaEnhancer } from './components/Blocks/Button/button_style_schema_enhancer';
import PageTitleView from './components/Blocks/Teaser/PageTitleView';
import FeaturedH1View from './components/Blocks/Teaser/FeaturedH1View';
import FeaturedH2View from './components/Blocks/Teaser/FeaturedH2View';
import FeaturedH2CenterView from './components/Blocks/Teaser/FeaturedH2CenterView';
import FeaturedOverflow from './components/Blocks/Teaser/FeaturedOverflow';
import FeaturedImageLeft from './components/Blocks/Teaser/FeaturedImageLeft';
import FeaturedImageRight from './components/Blocks/Teaser/FeaturedImageRight';
import ImageGalleryView from './components/Blocks/ImageGallery/ImageGalleryView';
import ImageGalleryEdit from './components/Blocks/ImageGallery/ImageGalleryEdit';
import SubscribeView from './components/Blocks/Subscribe/SubscribeView';
import SubscribeEdit from './components/Blocks/Subscribe/SubscribeEdit';
import FBCBody from './components/Blocks/Slider/FBCBody';
import { AccordionSchemaEnhancer } from './components/Blocks/Accordion/schema';

import {
  featuredSchemaEnhancer,
  featuredButtonsSchemaEnhancer,
} from './components/Blocks/Teaser/featured_schema_enhancer';
import imageSVG from '@plone/volto/icons/image.svg';
import { composeSchema } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import LeftColumnFacets from './components/Blocks/Search/LeftColumnFacets';
import { LocationGridListingItemTemplate } from './components/Blocks/Listing/LocationGridListingItemTemplate';
import { ServiceGridListingItemTemplate } from './components/Blocks/Listing/ServiceGridListingItemTemplate';

import { removeDefaultFields } from 'volto-fbc/components/utils';
import { GridTemplates } from './components/Blocks/Grid/GridTemplates';
import { LocationBlockSlot } from './components/LocationBlockSlot/LocationBlockSlot';
import GridListingBlockTemplate from './components/Blocks/Listing/GridTemplate';
import { fixedStyleSchema } from './editor/fixedStyleSchema';
import { formSchema } from './components/Blocks/Form/formSchema';
import {
  klaviyoId,
  selectionKlaviyoId,
} from './components/Blocks/Form/filedTypeExtenders';
import { additionalFields } from './components/Blocks/Form/additionalFields';
import { displayStyleSchema } from './editor/displayStyleSchema';

export function ContentTypeCondition(contentType) {
  return ({ content, location }) => {
    return (
      contentType.includes(content?.['@type']) ||
      contentType.some((type) => {
        return location.search.includes(`type=${encodeURIComponent(type)}`);
      })
    );
  };
}
const applyBlocks = (config) => {
  config.blocks.blocksConfig[COLUMNSBLOCK].gridSizes = {
    ...config.blocks.blocksConfig[COLUMNSBLOCK].gridSizes,
    halfWidth: {
      mobile: 12,
      tablet: 12,
      computer: 6,
    },
  };
  config.blocks.blocksConfig[COLUMNSBLOCK].view = (props) => (
    <div className={props.className} style={props.style}>
      <ColumnsBlockView {...props} />
    </div>
  );
  config.blocks.initialBlocks.LocationBlock = [
    {
      '@type': 'slate',
      plaintext: 'Encabezado',
      value: [
        {
          children: [
            {
              text: 'Encabezado',
            },
          ],
          type: 'h4',
        },
      ],
    },
    {
      '@type': 'slate',
      plaintext: 'Texto descriptivo',
      value: [
        {
          children: [
            {
              text: 'Texto descriptivo',
            },
          ],
          type: 'p',
        },
      ],
    },
  ];

  config.blocks.blocksConfig['__button'].view = ButtonView;
  config.blocks.blocksConfig['__button'].schemaEnhancer = composeSchema(
    config.blocks.blocksConfig['__button'].schemaEnhancer,
    buttonSchemaEnhancer,
    addStyling,
    buttonStyleSchemaEnhancer,
    fixedStyleSchema,
  );

  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'subheader',
    component: LocationBlockSlot,
    predicates: [ContentTypeCondition(['LocationBlock'])],
  });

  config.blocks.blocksConfig.teaser.variations = [
    {
      id: 'page-title',
      isDefault: true,
      title: 'Page title',
      template: PageTitleView,
      schemaEnhancer: composeSchema(featuredSchemaEnhancer, (props) =>
        removeDefaultFields(props.schema, ['head_title', 'overwrite']),
      ),
    },
    {
      id: 'featured-h1',
      isDefault: false,
      title: 'Featured (h1)',
      template: FeaturedH1View,
      schemaEnhancer: composeSchema(
        featuredSchemaEnhancer,
        featuredButtonsSchemaEnhancer,
        (props) =>
          removeDefaultFields(props.schema, ['head_title', 'overwrite']),
      ),
    },
    {
      id: 'featured-2',
      isDefault: false,
      title: 'Featured (h2)',
      template: FeaturedH2View,
      schemaEnhancer: composeSchema(
        featuredSchemaEnhancer,
        featuredButtonsSchemaEnhancer,
        (props) =>
          removeDefaultFields(props.schema, ['head_title', 'overwrite']),
      ),
    },
    {
      id: 'featured-2-center',
      isDefault: false,
      title: 'Featured (h2) Center',
      template: FeaturedH2CenterView,
      schemaEnhancer: composeSchema(
        featuredSchemaEnhancer,
        featuredButtonsSchemaEnhancer,
        (props) =>
          removeDefaultFields(props.schema, ['head_title', 'overwrite']),
      ),
    },
    {
      id: 'featured-overflow',
      isDefault: false,
      title: 'Featured (overflow)',
      template: FeaturedOverflow,
      schemaEnhancer: composeSchema(featuredSchemaEnhancer, (props) =>
        removeDefaultFields(props.schema, [
          'head_title',
          'overwrite',
          'description2',
        ]),
      ),
    },
    {
      id: 'featured-image-left',
      isDefault: false,
      title: 'Featured (image-left)',
      template: FeaturedImageLeft,
      schemaEnhancer: composeSchema(featuredSchemaEnhancer, (props) =>
        removeDefaultFields(props.schema, ['head_title', 'overwrite']),
      ),
    },
    {
      id: 'featured-image-right',
      isDefault: false,
      title: 'Featured (image-right)',
      template: FeaturedImageRight,
      schemaEnhancer: composeSchema(featuredSchemaEnhancer, (props) =>
        removeDefaultFields(props.schema, ['head_title', 'overwrite']),
      ),
    },
  ];

  // ImageGallery block
  config.blocks.blocksConfig.imageGalleryBlock = {
    id: 'imageGalleryBlock',
    title: 'Image Gallery',
    icon: imageSVG,
    view: ImageGalleryView,
    edit: ImageGalleryEdit,
    group: 'common',
    fullobjects: true,
    sidebarTab: 1,
  };

  // Subscribe block
  config.blocks.blocksConfig.subscribeBlock = {
    id: 'subscribeBlock',
    title: 'Subscribe',
    icon: imageSVG,
    view: SubscribeView,
    edit: SubscribeEdit,
    group: 'common',
    sidebarTab: 1,
    // fullobjects: true,
  };

  // Disable modifications added by volto-light-theme
  // for teasers that go inside gridBlock

  // Here we add all variation, may be it makes sense to filter out the unwanted ones such us the variations
  // that take the full width of the page. To be decided later
  config.blocks.blocksConfig.gridBlock.blocksConfig.teaser.variations =
    cloneDeep(config.blocks.blocksConfig.teaser.variations);

  config.blocks.blocksConfig.gridBlock.blocksConfig.teaser.schemaEnhancer =
    cloneDeep(config.blocks.blocksConfig.teaser.schemaEnhancer);

  // Extra variations for listing & Search
  // Recover left-side facet template for search blcok
  config.blocks.blocksConfig.search = {
    ...config.blocks.blocksConfig.search,
    variations: [
      // ...config.blocks.blocksConfig.search.variations,
      {
        id: 'facetsLeftSide',
        title: 'Facets on left side',
        view: LeftColumnFacets,
        isDefault: true,
      },
    ],
  };
  config.blocks.blocksConfig.listing.variations = [
    // ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'grid',
      title: 'Grid',
      template: GridListingBlockTemplate,
      default: true,
    },
    // {
    //   id: 'LocationGridListingItemTemplate',
    //   title: 'LocationGridListingItemTemplate',
    //   template: LocationGridListingItemTemplate,
    // },
    // {
    //   id: 'ServiceGridListingItemTemplate',
    //   title: 'ServiceGridListingItemTemplate',
    //   template: ServiceGridListingItemTemplate,
    // },
  ];

  // Custom template for Locations in Grid Variation
  config.registerComponent({
    name: 'GridListingItemTemplate',
    component: LocationGridListingItemTemplate,
    dependencies: 'Location',
  });

  // Custom template for Service in Grid Variation
  config.registerComponent({
    name: 'GridListingItemTemplate',
    component: ServiceGridListingItemTemplate,
    dependencies: 'Service',
  });

  // Custom column number in grid
  config.blocks.blocksConfig.gridBlock.templates = GridTemplates;

  // Allow button in grid
  config.blocks.blocksConfig.gridBlock.allowedBlocks.push('__button');
  config.blocks.blocksConfig.gridBlock.blocksConfig['__button'] = cloneDeep(
    config.blocks.blocksConfig.__button,
  );
  // Allow teaser with variations in grid
  config.blocks.blocksConfig.gridBlock.blocksConfig.teaser = cloneDeep(
    config.blocks.blocksConfig.teaser,
  );

  // Allow accordion in grid
  config.blocks.blocksConfig.accordion.blocksConfig.teaser.schemaEnhancer =
    config.blocks.blocksConfig.teaser.schemaEnhancer;

  config.blocks.blocksConfig.accordion.blocksConfig.teaser.variations =
    cloneDeep(config.blocks.blocksConfig.teaser.variations);

  config.blocks.blocksConfig.accordion.allowedBlocks.push(COLUMNSBLOCK);
  config.blocks.blocksConfig.accordion.blocksConfig[COLUMNSBLOCK] = cloneDeep(
    config.blocks.blocksConfig[COLUMNSBLOCK],
  );
  config.blocks.blocksConfig.accordion.titleIcons = {
    ...config.blocks.blocksConfig.accordion.titleIcons,
    opened: { leftPosition: 'minus', rightPosition: 'minus' },
    closed: { leftPosition: 'plus', rightPosition: 'plus' },
    iconComponent: 'SemanticIcon',
  };

  config.blocks.blocksConfig['image'].schemaEnhancer = composeSchema(
    config.blocks.blocksConfig['image'].schemaEnhancer,
    displayStyleSchema,
  );

  // Accordion internal `blocksConfig` amendments
  // We cloneDeep the blocksConfig to avoid modifying the original object
  // in subsequent modifications of the accordion block config
  config.blocks.blocksConfig.image.blocksConfig = cloneDeep(
    config.blocks.blocksConfig,
  );
  config.blocks.blocksConfig.slider.variations = [
    {
      id: 'fbcMobile',
      title: 'Mobile',
      view: FBCBody,
      isDefault: true,
    },
  ];
  config.blocks.blocksConfig.slider.schemaEnhancer = composeSchema(
    config.blocks.blocksConfig.slider.schemaEnhancer,
    displayStyleSchema,
  );

  config.blocks.blocksConfig.accordion.schemaEnhancer = composeSchema(
    AccordionSchemaEnhancer,
  );

  // Accordion internal `blocksConfig` amendments
  // We cloneDeep the blocksConfig to avoid modifying the original object
  // in subsequent modifications of the accordion block config
  config.blocks.blocksConfig.accordion.blocksConfig = cloneDeep(
    config.blocks.blocksConfig,
  );

  config.blocks.blocksConfig.form.formSchema = formSchema(config);
  config.blocks.blocksConfig.form.additionalFields = additionalFields;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.from = klaviyoId;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.text = klaviyoId;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.textarea = klaviyoId;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.select =
    selectionKlaviyoId;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.phone = klaviyoId;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.single_choice =
    selectionKlaviyoId;
  config.blocks.blocksConfig.form.fieldTypeSchemaExtenders.multiple_choice =
    selectionKlaviyoId;

  // Blocks grouping
  config.blocks.blocksConfig.heading.mostUsed = false;
  config.blocks.blocksConfig.separator.mostUsed = false;
  config.blocks.blocksConfig.highlight.mostUsed = false;
  config.blocks.blocksConfig.introduction.mostUsed = false;
  config.blocks.blocksConfig.form.mostUsed = false;
  config.blocks.blocksConfig.form.group = 'common';
  config.blocks.blocksConfig[COLUMNSBLOCK].mostUsed = true;
  config.blocks.blocksConfig.slate.mostUsed = true;

  //Blocks ordering
  const blocksOrder = [
    'slate',
    '__button',
    COLUMNSBLOCK,
    'teaser',
    'accordion',
    'gridBlock',
    'image',
    'video',
    'listing',
  ];
  blocksOrder.forEach((blockId) => {
    const bConfig = { ...config.blocks.blocksConfig[blockId] };
    delete config.blocks.blocksConfig[blockId];
    config.blocks.blocksConfig[blockId] = bConfig;
  });

  config.settings.querystringSearchGet = true;
};

export default applyBlocks;
